import React from 'react'
import { observer } from 'mobx-react'
import cn from 'classnames'

import ErrorStore from 'stores/error/ErrorStore'
import LayoutStore from 'stores/layout/LayoutStore'

import Dialog from 'components/dialog/Dialog'
import Button from 'components/button/Button'

import ChevronDown from 'assets/icons/chevron-down.svg'
import styles from './common.scss'

interface IProps {}

interface IState {
  isDetailsOpen: boolean
}

class ClientError extends React.PureComponent<IProps, IState> {
  state = {
    isDetailsOpen: false,
  }

  handleToggleDetails = () => {
    this.setState(state => ({ isDetailsOpen: !state.isDetailsOpen }))
  }

  handleDismiss = () => {
    LayoutStore.updateError({ visible: false })
  }

  render() {
    const { isDetailsOpen } = this.state

    return (
      <Dialog
        className={styles.container}
        error
        title="Prisma Client Error"
        primaryButton={
          <Button className={styles.action} onClick={this.handleDismiss}>
            Dismiss
          </Button>
        }
        secondaryButton={
          <Button
            ghost
            className={cn(styles.action, styles.discardBtn)}
            onClick={() => {}}
          >
            <a
              href="https://www.prisma.io/docs/reference/tools-and-interfaces/prisma-client/error-reference#query-engine"
              target="_blank"
              rel="noreferrer noopener"
            >
              Error Documentation
            </a>
          </Button>
        }
      >
        <div className={styles.content}>
          <p className={styles.description}>{ErrorStore.description}</p>

          <Button
            ghost
            className={cn(styles.detailsBtn, {
              [styles.open]: isDetailsOpen,
            })}
            onClick={this.handleToggleDetails}
          >
            <>
              <ChevronDown />
              {isDetailsOpen ? 'Hide' : 'Show'} details
            </>
          </Button>
          {isDetailsOpen && (
            <pre className={styles.dump}>{ErrorStore.dump}</pre>
          )}
        </div>
      </Dialog>
    )
  }
}

export default observer(ClientError)
